<template>
    <b-modal
        size="md"
        v-model="modalShow"
        title="サービスモデル編集"
        ok-title="編集"
        ok-variant="yokumiru-orange"
        :ok-disabled="inProgress"
        ok-only
        @ok="handleOk"
        @hidden="close">
        <form
            v-if="plan !== null"
            @submit.stop.prevent="editPlan">
            <div class="row">
                <div class="col-12">
                    <div class="form-group m-form__group">
                        <label for="name" class="is-required-ja">サービスモデル名</label>
                        <input
                            v-model="plan.name"
                            id="name"
                            type="text"
                            class="form-control m-input"
                            :class="{ 'is-invalid' : errors.name }"
                            placeholder="サービスモデル名を入力">
                        <div
                            v-if="errors.name"
                            class="invalid-feedback d-block mt-1">
                            {{ errors.name[0]}}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group m-form__group">
                        <label for="key" class="is-required-ja">サービスモデルKEY</label>
                        <div class="custom-control custom-radio">
                            <input
                                v-model="planCategory"
                                disabled
                                name="plan_category"
                                id="plan_category_travel"
                                class="custom-control-input"
                                value="TRAVEL"
                                type="radio">
                            <label
                                class="custom-control-label"
                                for="plan_category_travel">
                                海外旅行ドクターパス
                            </label>
                        </div>
                        <div class="custom-control custom-radio mb-2">
                            <input
                                v-model="planCategory"
                                disabled
                                name="plan_category"
                                id="plan_category_study_abroad"
                                class="custom-control-input"
                                value="STUDY_ABROAD"
                                type="radio">
                            <label
                                class="custom-control-label"
                                for="plan_category_study_abroad">
                                留学ドクターパス
                            </label>
                        </div>
                        <div class="d-flex align-items-center">
                            <input
                                v-model="plan.key"
                                readonly
                                id="name"
                                type="text"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.key }"
                                placeholder="サービスモデルKEYを入力">
                        </div>
                        <div
                            v-if="errors.key"
                            class="invalid-feedback d-block mt-1">
                            {{ errors.key[0]}}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group m-form__group">
                        <label for="plan_type" class="is-required-ja">タイプ</label>
                        <select
                            v-model="plan.plan_type"
                            :disabled="isUsing"
                            id="plan_type"
                            class="form-control">
                            <option :value="null">タイプを選択してください</option>
                            <option
                                v-for="planType in planTypes.selectable"
                                :value="planType.value">
                                {{ planType.text }}
                            </option>
                        </select>
                        <div
                            v-if="errors.plan_type"
                            class="invalid-feedback d-block mt-1">
                            {{ errors.plan_type[0]}}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="mb-3">
                        <label for="price" class="is-required-ja">金額</label>
                        <input
                            v-model="plan.price"
                            :disabled="isUsing"
                            type="text"
                            id="price"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.price }"
                            placeholder="金額を入力">
                        <div
                            v-if="errors.price"
                            class="invalid-feedback d-block">
                            {{ errors.price[0] }}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group m-form__group">
                        <label for="cycle_unit" class="is-required-ja">課金単位</label>
                        <select
                            v-model="plan.cycle_unit"
                            :disabled="isUsing"
                            id="cycle_unit"
                            class="form-control">
                            <option :value="null">課金単位を選択してください</option>
                            <option
                                v-for="cycleUnit in cycleUnits.selectable"
                                :value="cycleUnit.value">
                                {{ cycleUnit.text }}
                            </option>
                        </select>
                        <div
                            v-if="errors.cycle_unit"
                            class="invalid-feedback d-block mt-1">
                            {{ errors.cycle_unit[0]}}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="mb-3">
                        <label for="min_duration">最低利用期間</label>
                        <div class="d-flex align-items-center">
                            <input
                                v-model="plan.min_duration"
                                type="text"
                                id="min_duration"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.min_duration }"
                                placeholder="最低利用期間を入力">
                            <span v-if="plan.cycle_unit === cycleUnits.daily" class="text-muted ml-1">日</span>
                        </div>
                        <div
                            v-if="errors.min_duration"
                            class="invalid-feedback d-block">
                            {{ errors.min_duration[0] }}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="mb-3">
                        <label for="term_url">規約URL</label>
                        <input
                            v-model="plan.term_url"
                            type="text"
                            id="term_url"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.term_url }"
                            placeholder="規約URLを入力">
                        <div
                            v-if="errors.term_url"
                            class="invalid-feedback d-block">
                            {{ errors.term_url[0] }}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="mb-3">
                        <label for="formrun_uid">フォームランUID</label>
                        <input
                            v-model="plan.formrun_uid"
                            type="text"
                            id="formrun_uid"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.formrun_uid }"
                            placeholder="フォームランUIDを入力">
                        <div
                            v-if="errors.formrun_uid"
                            class="invalid-feedback d-block">
                            {{ errors.formrun_uid[0] }}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="mb-3">
                        <label for="remarks">備考</label>
                        <input
                            v-model="plan.remarks"
                            type="text"
                            id="remarks"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.remarks }"
                            placeholder="備考を入力">
                        <div
                            v-if="errors.remarks"
                            class="invalid-feedback d-block">
                            {{ errors.remarks[0] }}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        props: {
            plans: {
                type: Array,
                required: true,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                modalShow: false,
                planTypes: constants.planTypes,
                cycleUnits: constants.cycleUnits,
                plan: null,
                planCategory: '',
                errors: {},
            }
        },

        computed: {
            /**
             * 利用中のサービスモデルかどうか
             * @return {boolean}
             */
            isUsing: function () {
                if (!this.plan) return false
                return this.plan.users_count > 0
                    || this.plan.groups_count > 0
                    || this.plan.with_trashed_subscriptions_count > 0
                    || constants.plans.common.includes(this.plan.key)
            },
        },

        created: function () {
            bus.$on('open-modal-admin-edit-plan', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-admin-edit-plan')
        },

        methods: {
            /**
             * モーダル表示
             * @param {object} plan
             */
            open: function (plan) {
                this.initPlan(plan)
                this.errors = {}
                this.modalShow = true
            },

            /**
             * 入力値の初期化
             * @param {object} plan
             */
            initPlan: function (plan) {
                this.plan = {...plan}

                if (this.helper.isTravelPlan(plan)) {
                    this.planCategory = 'TRAVEL'
                }
                else if (this.helper.isStudyAbroadPlan(plan)) {
                    this.planCategory = 'STUDY_ABROAD'
                }
            },

            /**
             * 追加ボタン押下時
             *
             * @param {object} e
             */
            handleOk: function (e) {
                e.preventDefault()
                this.editPlan()
            },

            /**
             * 相談科追加
             */
            editPlan: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = constants.admin.plans.endpoint.base
                await axios.put(`${endpoint}/${this.plan.id}`, this.plan)
                    .then(() => {
                        bus.$emit('alert-success', 'サービスモデルを編集しました。')
                        bus.$emit('plan-edited')
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            if (response.data.errors.hasOwnProperty('message')) {
                                bus.$emit('alert-danger', response.data.errors.message[0])
                            }
                            else {
                                this.errors = response.data.errors
                                bus.$emit('alert-danger')
                            }
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    });

                this.inProgress = false
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.modalShow = false
            },
        },
    }
</script>
